import dayjs, { Dayjs } from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import { JobDashboardRange } from './job-dashboard-configuration';

dayjs.extend(quarterOfYear);

const HOURLY_RANGES: Partial<Record<JobDashboardRange, number>> = {
  [JobDashboardRange.LAST_1_HOURS]: 1,
  [JobDashboardRange.LAST_2_HOURS]: 2,
  [JobDashboardRange.LAST_4_HOURS]: 4,
  [JobDashboardRange.LAST_8_HOURS]: 8,
  [JobDashboardRange.LAST_12_HOURS]: 12,
};

export function getFromForRange(
  range: JobDashboardRange,
  referenceTime = dayjs(),
): Dayjs {
  const hours = HOURLY_RANGES[range];
  if (hours !== undefined) {
    return referenceTime.subtract(hours, 'hour');
  }
  const now = referenceTime.startOf('day');

  switch (range) {
    case JobDashboardRange.TODAY:
      return now.startOf('day');
    case JobDashboardRange.LAST_DAY:
      return now.subtract(1, 'day').startOf('day');
    case JobDashboardRange.THIS_WEEK:
      return now.startOf('week');
    case JobDashboardRange.LAST_WEEK:
      return now.subtract(1, 'week').startOf('week');
    case JobDashboardRange.THIS_MONTH:
      return now.startOf('month');
    case JobDashboardRange.LAST_MONTH:
      return now.subtract(1, 'month').startOf('month');
    case JobDashboardRange.THIS_QUARTER:
      return now.startOf('quarter');
    case JobDashboardRange.THIS_YEAR:
      return now.startOf('year');
    case JobDashboardRange.LAST_7_DAYS:
      return now.subtract(6, 'day');
    case JobDashboardRange.LAST_30_DAYS:
      return now.subtract(30, 'day');
    case JobDashboardRange.LAST_90_DAYS:
      return now.subtract(90, 'day');
    case JobDashboardRange.LAST_365_DAYS:
      return now.subtract(365, 'day');
    case JobDashboardRange.ALL_TIME:
      return dayjs('1970-01-01');
    case JobDashboardRange.CUSTOM:
      throw new Error('Custom range requires manual input');
    default:
      return now;
  }
}

export function getToForRange(
  range: JobDashboardRange,
  referenceTime = dayjs(),
): Dayjs {
  if (HOURLY_RANGES[range] !== undefined) {
    return referenceTime;
  }
  const now = referenceTime.endOf('day');

  switch (range) {
    case JobDashboardRange.TODAY:
    case JobDashboardRange.THIS_WEEK:
    case JobDashboardRange.THIS_MONTH:
    case JobDashboardRange.THIS_QUARTER:
    case JobDashboardRange.THIS_YEAR:
    case JobDashboardRange.LAST_7_DAYS:
    case JobDashboardRange.LAST_30_DAYS:
    case JobDashboardRange.LAST_90_DAYS:
    case JobDashboardRange.LAST_365_DAYS:
    case JobDashboardRange.ALL_TIME:
      return now;
    case JobDashboardRange.LAST_DAY:
      return now.subtract(1, 'day').endOf('day');
    case JobDashboardRange.LAST_WEEK:
      return now.subtract(1, 'week').endOf('week');
    case JobDashboardRange.LAST_MONTH:
      return now.subtract(1, 'month').endOf('month');
    case JobDashboardRange.CUSTOM:
      throw new Error('Custom range requires manual input');
    default:
      return now;
  }
}
